/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateCopyGroupRequest} from '@cash-web/protos/squareup/consentsys/service.pb'
import {CopyGroupResponse} from '@cash-web/protos/squareup/consentsys/service.pb'


export const createCopyGroup = (request: CreateCopyGroupRequest, options?: CashRequestOptions) => post<CreateCopyGroupRequest, CopyGroupResponse>("/2.0/cash/create-copy-group", request, {...options, rejectOnError: true })